import { render, staticRenderFns } from "./RptMatchdayreport.vue?vue&type=template&id=21daaa3e&scoped=true&"
import script from "./RptMatchdayreport.vue?vue&type=script&lang=js&"
export * from "./RptMatchdayreport.vue?vue&type=script&lang=js&"
import style0 from "./RptMatchdayreport.vue?vue&type=style&index=0&id=21daaa3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daaa3e",
  null
  
)

export default component.exports